<template>
  <div class="rtl">
    <m-form
        title="افزونه ها"
        :isEditing.sync="isEditing"
        :showListBtn="false"
        :showList="false"
        :show-submit-and-clear-btn="false"
        :show-list-btn="false"
        :show-clear-btn="false"
        :can-delete="false"
        @submit="submit"
        :show-navigation-btns="false"
    >
      <template #default>
        <v-row>
          <v-col cols="12">
            <v-simple-table>
              <thead>
              <tr>
                <th style="width: 50px">ترتیب</th>
                <th>نام</th>
                <th style="width: 120px">قیمت</th>
                <th style="width: 80px">تمدید اجباری</th>
                <th style="width: 80px">فعال</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="extension in extensions">
                <td>
                  <v-text-field v-model="extension.order" type="number" :disabled="!isEditing"/>
                </td>
                <td>{{ extension.name_display }}</td>
                <td>
                  <money v-model="extension.price" :disabled="!isEditing"/>
                </td>
                <td>
                  <div class="mx-5">
                    <v-switch v-model="extension.is_permanent" disabled/>
                  </div>
                </td>
                <td>
                  <div class="mx-5">
                    <v-switch v-model="extension.is_active" :disabled="!isEditing"/>
                  </div>
                </td>
              </tr>
              </tbody>
            </v-simple-table>


          </v-col>
        </v-row>
      </template>
    </m-form>
  </div>
</template>
<script>
import {MFormMixin} from "@/components/m-form";

export default {
  mixins: [MFormMixin],
  data() {
    return {
      baseUrl: "sobhanAdmin/extensions/",
      appendSlash: true,
      hasList: false,
      hasIdProp: false,
      extensions: [],
      isEditing: false,
    };
  },
  methods: {
    getData() {
      this.request({
        url: this.endpoint(this.baseUrl),
        success: (data) => {
          this.extensions = data;
        }
      })
    },
    getSerialized() {
      return this.extensions
    },
  },
};
</script>
